export const E_RAND_TYPES = [
  '아파트', '주상복합', '오피스텔', '단독', '다가구', '전원주택', '상가주택', '연립', '다세대', '원룸',
  '상가점포', '사무실', '상업용건물', '', '기타건물', '숙박시설', '토지', '공장', '지식산업센터', '창고',
];

export const DEAL_TYPES = ['매매', '전세', '월세'];

export const DIRECTIONS = [
  '선택안함', '동', '서', '남', '북', '남동', '남서', '북동', '북서',
];

export const BUILDING_USES = {
  1: '단독주택', 2: '공동주택', 3: '제1종 근린생활시설', 4: '제2종 근린생활시설',
  5: '문화 및 집회시설', 6: '종교시설', 7: '판매시설', 8: '운수시설',
  9: '의료시설', 10: '교육연구시설', 11: '노유자시설', 12: '수련시설',
  13: '운동시설', 14: '업무시설', 15: '숙박시설', 16: '위락시설',
  17: '공장', 18: '창고시설', 19: '위험물 저장 및 처리 시설', 20: '자동차 관련 시설',
  21: '동물 및 식물 관련 시설', 22: '자원순환 관련 시설', 23: '교정 및 군사 시설',
  24: '방송통신시설', 25: '발전시설', 26: '묘지 관련 시설', 27: '관광 휴게시설',
  28: '장례시설', 29: '야영장 시설', 30: '미등기건물', 31: '그 밖에 토지의 정착물',
};

export const USE_AREAS = {
  1: '제1종전용주거지역', 2: '제2종전용주거지역', 3: '제1종일반주거지역',
  4: '제2종일반주거지역', 5: '제3종일반주거지역', 6: '준주거지역',
  7: '중심상업지역', 8: '일반상업지역', 9: '근린상업지역', 10: '유통상업지역',
  11: '전용공업지역', 12: '일반공업지역', 13: '준공업지역',
  14: '보전녹지지역', 15: '생산녹지지역', 16: '자연녹지지역',
  17: '보전관리지역', 18: '생산관리지역', 19: '계획관리지역',
  20: '농림지역', 21: '자연환경보전지역',
};

export const LAND_PURPOSES = [
  '대', '전', '답', '임야', '과수원', '목장용지', '광천지', '염전',
  '공장용지', '학교용지', '주차장', '주유소용지', '창고용지', '도로',
  '철도용지', '제방', '하천', '구거', '유지', '양어장', '수도용지',
  '공원', '체육용지', '유원지', '종교용지', '사적지', '묘지', '잡종지',
];

export const FLOOR_TYPES = { 0: '고층', 1: '중층', 2: '저층' };

export const DIRECTION_POINTS = { 1: '거실 기준', 2: '안방 기준' };

export const ENTRY_ROADS = { 1: '있음', 2: '없음' };

// 부동산유형 그룹 — ProfileSection, BasicBuildingSection 등에서 필드 분기용
export function getTypeGroup(eRandType) {
  const t = Number(eRandType);
  if ([0, 1].includes(t)) return 'apt';           // 아파트, 주상복합
  if ([2, 7, 8, 20].includes(t)) return 'villa';    // 오피스텔, 연립, 다세대, 생활숙박시설
  if ([3, 4, 5].includes(t)) return 'house';       // 단독, 다가구, 전원주택
  if (t === 6) return 'shopHouse';                  // 상가주택
  if (t === 9) return 'oneRoom';                    // 원룸
  if ([10, 11, 18].includes(t)) return 'commercial'; // 상가점포, 사무실, 지식산업센터
  if ([12, 14].includes(t)) return 'building';     // 상업용건물, 기타건물
  if (t === 15) return 'hotel';                     // 숙박시설
  if (t === 16) return 'land';                      // 토지
  if ([17, 19].includes(t)) return 'industrial';   // 공장, 창고
  return 'building';
}

export function getLabel(value, map) {
  if (value == null) return '-';
  if (Array.isArray(map)) return map[value] || '-';
  return map[value] || '-';
}

export function getLandPurpose(sale) {
  const label = getLabel(sale.land_purpose, LAND_PURPOSES);
  if (label !== '-') return label;
  return sale.land_purpose_text || '-';
}

export function formatArea(val) {
  if (val == null || val === '') return '-';
  const n = Number(val);
  if (isNaN(n)) return '-';
  return `${n.toLocaleString()}㎡`;
}

export function formatPercent(val) {
  if (val == null || val === '') return '-';
  const n = Number(val);
  if (isNaN(n)) return '-';
  return `${n}%`;
}

export function formatFloor(sale) {
  const { floor_cnt, floor_total, floor_type, under_floor } = sale || {};
  if (floor_type != null && floor_type >= 0) {
    return FLOOR_TYPES[floor_type] || '-';
  }
  const parts = [];
  if (floor_cnt != null) parts.push(`${floor_cnt}층`);
  if (floor_total != null) parts.push(`${floor_total}층`);
  if (parts.length) return parts.join(' / ');
  if (under_floor) return `지하 ${under_floor}층`;
  return '-';
}

export function formatAvailableDate(value, discussable) {
  let str = '';
  if (!value || value === '') {
    str = '즉시입주';
  } else {
    const s = String(value).replace(/\D/g, '');
    const year = s.substring(0, 4);
    const month = s.substring(4, 6);
    const day = s.substring(6, 8);
    str = `${year}년 ${month}월`;
    if (day) str += ` ${day}일`;
  }
  if (discussable == 1 || discussable === true) {
    str += ' (협의가능)';
  }
  return str;
}

export function formatPrice(value, deal_type, deposit, monthly) {
  const fmt = (v) => {
    if (v == null || v === '') return '-';
    const n = Number(v);
    if (isNaN(n)) return '-';
    if (n === 0) return '0';
    if (n >= 10000) return `${Math.floor(n / 10000).toLocaleString()}억${n % 10000 ? ` ${(n % 10000).toLocaleString()}만원` : ''}`;
    return `${n.toLocaleString()}만원`;
  };

  const dt = Number(deal_type);
  if (dt === 2 && (deposit || monthly)) {
    return `${fmt(deposit)} / ${fmt(monthly)}`;
  }
  if (dt === 1 && deposit) {
    return fmt(deposit);
  }
  return fmt(value);
}
